import React, { useState, useEffect, useRef } from 'react';
import {
  Grid,
  Paper,
  Typography,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Menu,
  MenuItem,
  Button,
  TextField,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import axios from 'axios'
import moment from 'moment';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import { ArrowUpward, ArrowDownward, Sort, Clear, Search, Flare as AutoAwesome, History } from '@material-ui/icons';
import { useStyles, mapContainerStyle } from '../DailyScheduleMapViewStyles';
import ServiceHistoryModal from './ServiceHistoryModal';

import {
  ClosestLocationDetails,
  ActiveMarkerDetails,
  CustomTabPanel,
  UnassignedJobsList,
} from './HelperComponents'


const JobsSidebar = ({ 
  tabValue,
  setTabValue,
  setActiveMarker,
  // setState,
  onClearActiveMarker,
  handleClickAssign,
  handleUnassignFromCrew,
  unassignedJobs,
  sites,
  crews,
  weeklyRoutes,
  selectedCrew,
  selectedDate,
  jobSiteDetails,
  handleDateClick,
  filteredCrews,
  handleClickOnSiteNearby,
  highlightedNearbySite,
  activeMarker,
  activeRouteDetails,
  onShowSuggestions,
  onShowAllSitesToggle,
  siteFilterType,
  onSiteFilterTypeChange,
  highlightedSite,
  onHighlightSite,
  url
 }) => {
  const classes = useStyles();
  
  // Always show the AllSitesDetails view (no tabs)
  return (
    <AllSitesDetails
      sites={sites}
      crews={crews}
      weeklyRoutes={weeklyRoutes}
      selectedDate={selectedDate}
      activeMarker={activeMarker}
      setActiveMarker={setActiveMarker}
      onClearActiveMarker={onClearActiveMarker}
      handleClickAssign={handleClickAssign}
      handleUnassignFromCrew={handleUnassignFromCrew}
      jobSiteDetails={jobSiteDetails}
      handleDateClick={handleDateClick}
      filteredCrews={filteredCrews}
      handleClickOnSiteNearby={handleClickOnSiteNearby}
      highlightedNearbySite={highlightedNearbySite}
      onShowAllSitesToggle={onShowAllSitesToggle}
      onShowSuggestions={onShowSuggestions}
      siteFilterType={siteFilterType}
      onSiteFilterTypeChange={onSiteFilterTypeChange}
      highlightedSite={highlightedSite}
      onHighlightSite={onHighlightSite}
      url={url}
    />
  )
}

const UnassignedJobsDetails = (
  { activeMarker, 
    sites, crews,
    weeklyRoutes, 
    selectedCrew,
     setActiveMarker, 
    onClearActiveMarker,
    handleClickAssign, 
    unassignedJobs,
    jobSiteDetails,
    filteredCrews,
    handleClickOnSiteNearby,
    highlightedNearbySite,
    selectedDate,
    handleDateClick,
    onShowSuggestions, // NEW
    url
  }) => {
  const classes = useStyles();
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: '#eee' }}>
      {/* Header */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        padding: '10px',
        backgroundColor: '#fff',
        borderBottom: '1px solid #ddd',
        flexShrink: 0
      }}>
        <Typography variant="h6">Unassigned Jobs ({unassignedJobs.length})</Typography>
        {activeMarker?._id && (
          <div style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
            <Button 
              onClick={onShowSuggestions}
              startIcon={<AutoAwesome />}
              variant="contained"
              color="primary"
              size="small"
            >
              Smart Suggestions
            </Button>
            <Button 
              onClick={onClearActiveMarker}
              startIcon={<FormatListBulletedIcon />}
              variant="outlined"
              color="primary"
              size="small"
            >
              Show All
            </Button>
          </div>
        )}
      </div>
      
      {/* Content */}
      <div style={{ flex: 1, overflow: 'auto', padding: '5px' }}>
        {activeMarker?._id ? (
          <div>
            <ActiveMarkerDetails 
              activeMarker={activeMarker} 
              jobSiteDetails={jobSiteDetails} 
              clickOnDate={handleDateClick}
              url={url}
            />
            <div style={{ marginTop: '10px' }}>
              <ClosestLocationDetails 
                jobSiteDetails={jobSiteDetails} 
                site={activeMarker} 
                crews={filteredCrews} 
                handleClickOnSiteNearby={handleClickOnSiteNearby} 
                highlightedNearbySite={highlightedNearbySite} 
              />
            </div>
          </div>
        ) : (
          <List style={{ padding: 0 }}>
            {unassignedJobs.map((job) => {
              let isActiveJob = activeMarker?._id === job._id;
              let hoursText = `Estimated Hours: ${job?.estimatedHours || 0}`;
              if (job?.avgSvcVisit) {
                hoursText = `${hoursText} (${job.avgSvcVisit}h In App)`;
              }
              return (
                <ListItem 
                  key={job._id} 
                  className={isActiveJob ? classes.activeJobItem : classes.unassignedJobItem} 
                  onClick={e => handleClickAssign(job)}
                  style={{ marginBottom: '8px' }}
                >
                  <ListItemText
                    primary={job.name}
                    secondary={`Frequency: ${job.frequency}`}
                  />
                  <ListItemText
                    primary={hoursText}
                  />
                  <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={e => handleClickAssign(job)}
                    size="small"
                  >
                    Assign
                  </Button>
                </ListItem>
              );
            })}
          </List>
        )}
      </div>
    </div>
  )
}

const AllSitesDetails = ({
  sites,
  crews,
  weeklyRoutes,
  selectedDate,
  activeMarker,
  setActiveMarker,
  onClearActiveMarker,
  handleClickAssign,
  handleUnassignFromCrew,
  jobSiteDetails,
  handleDateClick,
  filteredCrews,
  handleClickOnSiteNearby,
  highlightedNearbySite,
  onShowAllSitesToggle,
  onShowSuggestions,
  siteFilterType,
  onSiteFilterTypeChange,
  highlightedSite,
  onHighlightSite,
  url
}) => {
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState('');
  const filterType = siteFilterType || 'all'; // Use passed prop directly
  const [showAllSites, setShowAllSites] = useState(false); // Toggle for showing all sites on map
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [selectedHistorySite, setSelectedHistorySite] = useState(null);
  const [showTodayOnly, setShowTodayOnly] = useState(false); // New filter for today's sites
  
  // Update parent when filter changes
  const setFilterType = (newType) => {
    if (onSiteFilterTypeChange) {
      onSiteFilterTypeChange(newType);
    }
  };
  
  // Process sites with assignment info
  const processedSites = React.useMemo(() => {
    if (!sites) return [];
    
    const dayOfWeek = moment(selectedDate).format('dddd');
    const todaysRoutes = weeklyRoutes?.find(r => r.day === dayOfWeek);
    
    return sites.map(site => {
      // Check if site is assigned to a crew
      const assignedCrew = crews.find(c => c._id === site.crew);
      
      // Check if site is scheduled for today
      const isScheduledToday = todaysRoutes?.routes?.some(route => 
        route.stops?.some(stop => stop.siteId === site._id)
      );
      
      // Find which days this site is scheduled
      const scheduledDays = weeklyRoutes?.filter(dayRoute => 
        dayRoute.routes?.some(route => 
          route.stops?.some(stop => stop.siteId === site._id)
        )
      ).map(dayRoute => dayRoute.day) || [];
      
      return {
        ...site,
        isAssigned: !!assignedCrew,
        assignedCrew,
        isScheduledToday,
        scheduledDays,
        searchableText: `${site.name} ${site.address} ${site.clientName || ''} ${assignedCrew?.name || ''}`.toLowerCase()
      };
    });
  }, [sites, crews, weeklyRoutes, selectedDate]);
  
  // Filter sites based on search and filter type
  const filteredSites = React.useMemo(() => {
    return processedSites.filter(site => {
      // Search filter
      if (searchTerm && !site.searchableText.includes(searchTerm.toLowerCase())) {
        return false;
      }
      
      // Today filter (takes precedence)
      if (showTodayOnly && !site.isScheduledToday) return false;
      
      // Type filter (only apply if not filtering by today)
      if (!showTodayOnly) {
        if (filterType === 'assigned' && !site.isAssigned) return false;
        if (filterType === 'unassigned' && site.isAssigned) return false;
      }
      
      return true;
    });
  }, [processedSites, searchTerm, filterType, showTodayOnly]);
  
  const handleSiteClick = (site) => {
    // Just highlight the site, don't activate it
    if (onHighlightSite) {
      onHighlightSite(site);
    }
  };
  
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: '#eee' }}>
      {/* Header */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        padding: '10px',
        backgroundColor: '#fff',
        borderBottom: '1px solid #ddd',
        flexShrink: 0
      }}>
        <Typography variant="h6">
          {activeMarker?._id ? 'Property Details' : `Properties (${filteredSites.length} of ${sites.length})`}
        </Typography>
      </div>
      
      {/* Search and Filter Controls OR Active Site Actions */}
      <div style={{ padding: '8px', backgroundColor: '#fff', borderBottom: '1px solid #ddd', flexShrink: 0 }}>
        {activeMarker?._id ? (
          /* Active Site Actions */
          <div style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Button 
                onClick={onClearActiveMarker}
                startIcon={<FormatListBulletedIcon />}
                variant="outlined"
                size="small"
                fullWidth
              >
                Back to List
              </Button>
              <Button 
                onClick={onShowSuggestions}
                startIcon={<AutoAwesome />}
                variant="contained"
                color="primary"
                size="small"
                fullWidth
              >
                Smart Suggestions
              </Button>
            </div>
          </div>
        ) : (
          /* Search and Filters */
          <>
            <TextField
              fullWidth
              size="small"
              placeholder="Search sites..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: searchTerm && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setSearchTerm('')}>
                      <Clear />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              style={{ marginBottom: '8px' }}
            />
            
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '8px' }}>
              <Button
                size="small"
                variant={!showTodayOnly && filterType === 'all' ? 'contained' : 'outlined'}
                onClick={() => {
                  setShowTodayOnly(false);
                  setFilterType('all');
                }}
                disabled={showTodayOnly}
              >
                All ({sites.length})
              </Button>
              <Button
                size="small"
                variant={!showTodayOnly && filterType === 'assigned' ? 'contained' : 'outlined'}
                onClick={() => {
                  setShowTodayOnly(false);
                  setFilterType('assigned');
                }}
                color="primary"
                disabled={showTodayOnly}
              >
                Assigned ({processedSites.filter(s => s.isAssigned).length})
              </Button>
              <Button
                size="small"
                variant={!showTodayOnly && filterType === 'unassigned' ? 'contained' : 'outlined'}
                onClick={() => {
                  setShowTodayOnly(false);
                  setFilterType('unassigned');
                }}
                color="secondary"
                disabled={showTodayOnly}
              >
                Unassigned ({processedSites.filter(s => !s.isAssigned).length})
              </Button>
              <Button
                size="small"
                variant={showTodayOnly ? 'contained' : 'outlined'}
                onClick={() => setShowTodayOnly(!showTodayOnly)}
                style={{ 
                  backgroundColor: showTodayOnly ? '#4caf50' : 'transparent',
                  color: showTodayOnly ? '#fff' : '#4caf50',
                  borderColor: '#4caf50'
                }}
              >
                Today's Sites ({processedSites.filter(s => s.isScheduledToday).length})
              </Button>
            </div>
            
            <Button
              size="small"
              variant={showAllSites ? 'contained' : 'outlined'}
              onClick={() => {
                const newValue = !showAllSites;
                setShowAllSites(newValue);
                if (onShowAllSitesToggle) {
                  onShowAllSitesToggle(newValue);
                }
              }}
              style={{ 
                backgroundColor: showAllSites ? '#ff9800' : 'transparent',
                color: showAllSites ? '#fff' : '#ff9800',
                borderColor: '#ff9800'
              }}
            >
              {showAllSites ? '📅 Showing Sites From All Days' : '📍 Showing Today\'s Sites Only'}
            </Button>
          </>
        )}
      </div>
      
      {/* Content */}
      <div style={{ flex: 1, overflow: 'auto', padding: '5px' }}>
        {/* Active Site Details */}
        {activeMarker?._id ? (
          <div>
            <ActiveMarkerDetails 
              activeMarker={activeMarker} 
              jobSiteDetails={jobSiteDetails} 
              clickOnDate={handleDateClick}
              url={url}
            />
            <div style={{ marginTop: '10px' }}>
              <ClosestLocationDetails 
                jobSiteDetails={jobSiteDetails} 
                site={activeMarker} 
                crews={filteredCrews} 
                handleClickOnSiteNearby={handleClickOnSiteNearby} 
                highlightedNearbySite={highlightedNearbySite} 
              />
            </div>
          </div>
        ) : (
          /* Sites List */
          <List style={{ padding: 0 }}>
            {filteredSites.map((site, index) => {
              const hoursText = site.avgSvcVisit ? 
                `${site.estimatedHours || 0}h (${site.avgSvcVisit}h avg)` : 
                `${site.estimatedHours || 0}h`;
              
              return (
                <ListItem
                  key={site._id}
                  button
                  onClick={() => handleSiteClick(site)}
                  style={{
                    backgroundColor: highlightedSite?._id === site._id ? '#e3f2fd' : 
                                   activeMarker?._id === site._id ? '#f5f5f5' : 'transparent',
                    borderLeft: highlightedSite?._id === site._id ? '4px solid #2196f3' :
                               site.isAssigned ? `4px solid ${site.assignedCrew?.color || '#ccc'}` : '4px solid #ff5722',
                    marginBottom: '4px',
                    paddingTop: '12px',
                    paddingBottom: '12px',
                    transition: 'all 0.2s ease'
                  }}
                >
                  <ListItemText
                    primary={
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div style={{ flex: 1 }}>
                          <Typography variant="subtitle2">
                            {index + 1}. {site.name}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            {site.frequency} • {hoursText}
                          </Typography>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px' }}>
                          {site.isScheduledToday && (
                            <Typography variant="caption" color="primary" style={{ fontWeight: 'bold' }}>
                              Today
                            </Typography>
                          )}
                          <div style={{ display: 'flex', gap: '4px' }}>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedHistorySite(site);
                                setHistoryModalOpen(true);
                              }}
                              style={{ padding: '4px' }}
                              title="View Service History"
                            >
                              <History fontSize="small" />
                            </IconButton>
                            {site.isAssigned ? (
                              <Button 
                                size="small" 
                                variant="outlined" 
                                color="secondary"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  // Unassign from crew
                                  if (handleUnassignFromCrew) {
                                    console.log('Unassign this one', site)
                                    handleUnassignFromCrew(site);
                                  }
                                }}
                                style={{ minHeight: '24px', fontSize: '0.75rem' }}
                              >
                                Unassign
                              </Button>
                            ) : (
                              <Button 
                                size="small" 
                                variant="outlined" 
                                color="primary"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  // First set as active marker
                                  setActiveMarker(site);
                                  // Then trigger the assignment flow
                                  handleClickAssign(site);
                                }}
                                style={{ minHeight: '24px', fontSize: '0.75rem' }}
                              >
                                Assign
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    }
                    secondary={
                      <div style={{ marginTop: '4px' }}>
                        <Typography variant="caption" display="block" color="textSecondary">
                          {site.address}
                        </Typography>
                        <Typography variant="caption" style={{ 
                          color: site.isAssigned ? 'inherit' : '#ff5722',
                          fontWeight: site.isAssigned ? 'normal' : 'bold'
                        }}>
                          {site.isAssigned ? 
                            `Assigned to: ${site.assignedCrew.name}` : 
                            'Unassigned - Needs Scheduling'
                          }
                        </Typography>
                        {site.scheduledDays.length > 0 && (
                          <Typography variant="caption" display="block" color="primary">
                            Scheduled: {site.scheduledDays.join(', ')}
                          </Typography>
                        )}
                        {site.preferredDay && (
                          <Typography variant="caption" display="block">
                            Preferred: {site.preferredDay} {site.evenOrOddWeeks ? `(${site.evenOrOddWeeks} weeks)` : ''}
                          </Typography>
                        )}
                      </div>
                    }
                  />
                </ListItem>
              );
            })}
          </List>
        )}
      </div>
      
      {/* Service History Modal */}
      <ServiceHistoryModal
        open={historyModalOpen}
        onClose={() => {
          setHistoryModalOpen(false);
          setSelectedHistorySite(null);
        }}
        site={selectedHistorySite}
        url={url}
      />
    </div>
  );
};

export default JobsSidebar
